import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faFile, faHome, faPhone, faTasks, faUser } from "@fortawesome/free-solid-svg-icons";
import { NavLink } from "react-router-dom";
import "./Navbar.css";

const Navbar = () => {
  const links = [
    { to: "/", label: "Home", icon: faHome },
    { to: "/about", label: "About", icon: faUser },
    { to: "/projects", label: "Projects", icon: faTasks },
    { to: "/resume", label: "Resume", icon: faFile },
    { to: "/contacts", label: "Contact", icon: faPhone },
  ];

  return (
    <nav className="navbar navbar-expand-lg portfolio-navbar">
      <div className="container">
        <NavLink to="/" className="navbar-brand brand-mark" aria-label="Sagnik Pal home">
          SP
        </NavLink>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <FontAwesomeIcon icon={faBars} />
        </button>

        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav ms-auto">
            {links.map((link) => (
              <li className="nav-item" key={link.to}>
                <NavLink className="nav-link" to={link.to}>
                  <FontAwesomeIcon icon={link.icon} className="nav-icons" />
                  {link.label}
                </NavLink>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
